/* eslint-env jquery */

/*
 *  EventPopover mixin adds the methods for formatting event popovers (formatPopoverTitle and formatPopoverContent)
 *  and handles the logic in mounted() to set them up. To work properly, also pull in popover.css in App.vue.
 */

import {durationFormat} from '../model/formatters';

export const EventPopover = {
    methods: {
        formatPopoverTitle(event) {
            return event.secname ? `${event.sectitle}<br/>${event.secname}` : event.title;
        },
        formatPopoverContent(event) {
            var content = '';
            if (event.location) content += `Location: ${event.location}<br />`;
            if (event.attendeecnt) content += `Attendee count: ${event.attendeecnt}<br />`;
            if (event.roomcap) content += `Room capacity: ${event.roomcap}<br />`;
            if (event.facname) content += `Faculty: ${event.facname}<br />`;
            if (event.setupduration) content += `Setup time: ${durationFormat(event.setupduration)}<br />`;
            if (event.teardownduration) content += `Teardown time: ${durationFormat(event.teardownduration)}<br />`;
            return content;
        }
    },
    mounted() {
        $(this.$refs.eventTable).popover({
            html: true,
            trigger: 'click',
            placement: 'top',
            selector: 'tbody tr',
            container: '#app'
        });
        $(document).on('click', function(e) {
            $('[data-toggle="popover"],[data-original-title]').each(function() {
                if (
                    !$(this).is(e.target) &&
                    $(this).has(e.target).length === 0 &&
                    $('.popover').has(e.target).length === 0
                ) {
                    (
                        (
                            $(this)
                                .popover('hide')
                                .data('bs.popover') || {}
                        ).inState || {}
                    ).click = false;
                }
            });
        });
    }
};